"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withLazyHydrate = void 0;
const hoist_non_react_statics_1 = __importDefault(require("hoist-non-react-statics"));
const react_1 = __importDefault(require("react"));
const util_component_display_name_1 = require("@hotelplan/util.component.display-name");
const lazy_hydrate_1 = require("./lazy-hydrate");
function withLazyHydrate(Component, lazyHydrateProps) {
    function WishLazyHydrateComponent(props) {
        return (react_1.default.createElement(lazy_hydrate_1.LazyHydrate, Object.assign({}, lazyHydrateProps),
            react_1.default.createElement(Component, Object.assign({}, props), props.children)));
    }
    (0, hoist_non_react_statics_1.default)(WishLazyHydrateComponent, Component);
    if (process.env.NODE_ENV === 'development') {
        WishLazyHydrateComponent.displayName = `withLazyHydrate(${(0, util_component_display_name_1.getDisplayName)(Component)})`;
    }
    return WishLazyHydrateComponent;
}
exports.withLazyHydrate = withLazyHydrate;
//# sourceMappingURL=with-lazy-hydrate.js.map